<template>
  <footer class="footer">
    <div class="footer-border"></div>
    <div class="footer-content">
      <div class="footer-grid">
        <div>
          <h4 class="footer-title">Contacto</h4>
          <ul>
            <li class="footer-item">
              <svg
                class="footer-item__icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <a href="mailto:support@harmonix.ai">support@harmonix.ai</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">
          {{ copyright }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear().toString()
const copyright = `© ${currentYear} Harmonix. Todos los derechos reservados.`
</script>

<style scoped lang="postcss">
.footer {
  @apply relative overflow-hidden text-white mt-12;
  background-color: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(24px);
}

.footer-border {
  @apply absolute top-0 left-0 right-0 h-1;
  background: linear-gradient(90deg, #1e3a8a, #1e40af, #1e3a8a);
  box-shadow: 0 0 8px rgba(30, 58, 138, 0.6);
}

.footer-content {
  @apply relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8;
}

.footer-grid {
  @apply grid grid-cols-1 md:grid-cols-4 gap-4;
}

.footer-title {
  @apply font-medium mb-4 text-base text-white;
  font-family: inherit;
  letter-spacing: 0.5px;
  position: relative;
  display: inline-block;
  padding-bottom: 2px;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #1e3a8a, #1e40af, #1e3a8a);
  font-weight: 600;
}

/* Contact / Items */
.footer-item {
  @apply flex items-center text-white/90 text-sm transition-all duration-300;
}

.footer-item:hover {
  @apply text-white transform translate-x-1;
}
.footer-item__icon {
  @apply w-5 h-5 mr-2 fill-none stroke-current stroke-2;
}

/* Bottom bar */
.footer-bottom {
  @apply flex justify-end mt-8 pt-4 border-t border-white/10;
  position: relative;
}

.footer-bottom::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
}

.footer-copyright {
  @apply text-xs text-white/70 tracking-wide;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
</style>
